export const SET_EDUCATION = "SET_EDUCATION";
export const RESET_EDUCATION = "RESET_EDUCATION";